/** @jsxImportSource @emotion/react */
import React from "react";
import { Col, InputNumber, Row } from "antd";
import * as Styles from "./styles";

export interface DimensionInputProps {
  onChange: (value: string) => void;
}

interface Dimensions {
  width: number | null;
  depth: number | null;
  height: number | null;
}

const FIELDS: { key: keyof Dimensions; placeholder: string }[] = [
  { key: "width", placeholder: "W" },
  { key: "depth", placeholder: "D" },
  { key: "height", placeholder: "H" },
];

export const DimensionInput = ({ onChange }: DimensionInputProps) => {
  const [dimensions, setDimensions] = React.useState<Dimensions>({
    width: null,
    depth: null,
    height: null,
  });

  const apply = (next: Dimensions) => {
    setDimensions(next);
    const { width, depth, height } = next;
    if (width === null || depth === null || height === null) {
      onChange("");
      return;
    }
    onChange(`${width}x${depth}x${height}`);
  };

  return (
    <Row gutter={4}>
      {FIELDS.map((field) => (
        <Col span={8} key={field.key}>
          <InputNumber
            css={Styles.fullWidthStyle}
            placeholder={field.placeholder}
            min={0}
            value={dimensions[field.key] ?? undefined}
            onChange={(value) => apply({ ...dimensions, [field.key]: value })}
          />
        </Col>
      ))}
    </Row>
  );
};
